<template>
    <div class="My_popup">
        <div class="My_popup_wrap">
            <span class="My_popup_close"><a href="#닫기" @click.prevent="closeClickHandler">닫기</a></span>
            <div class="My-popup-title trash">
                코로나19 확진자 추이
            </div>
            <div class="grp_wrap" style="height:300px;">
                <chart chartid="125" :show-grp-value="true"></chart>
            </div>
        </div>
    </div>
</template>

<script>
import chart from '@/lib/grip.chart.vue';

export default {
    name: "CovidChartWin",
    methods: {
        closeClickHandler() {
            this.$emit("close-covid-chart-win");
        },
    },
    components: {
        chart
    }
}
</script>

<style scoped>

</style>
